import { createSlice } from '@reduxjs/toolkit';
import { ProjectData } from '../../components/map/mapData';

const initialState = {
  activeTab: 'all',
  editingPinId: null,
  editingBoundary: null, 
  // projectData: ProjectData,
  projectData: null,
  pinsLoaded: false,
  showLocationPicker: false,
  allPins:{
    location:[],
    product:[],
    beacon:[],
    amenity:[],
    safety:[],
    vertical:[],
    vertical_transport:[],
  },
  floorList : [],
  currentFloor : null,
  floorLoading : false,
  selectedPin:{},
  pinCount : {
    used_locations: 0,
    used_products: 0,
    total_locations: 0,
    total_products: 0,
  }
};

const projectItemSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setActiveTab(state, action) {
      state.activeTab = action.payload;
    },
    setEditingPinId(state, action) {
      state.editingPinId = action.payload;
    },
    setProjectData(state, action) { 
      state.projectData = {
        ...state.projectData,
        ...action.payload
      };
    },
    setAllPins(state, action) {
      state.allPins = action.payload;
      state.pinsLoaded = true;
    },
    setPinsByCategory(state, action) { 
      Object.assign(state.allPins, action.payload); 
    },
    setPinCount(state, action) { 
      state.pinCount = action.payload;
    },
    setFloorList(state, action) {
      state.floorList = action.payload;
    },
    setCurrentFloor(state, action) {
      const newId = action.payload?.enc_id ?? null;
      const oldId = state.currentFloor?.enc_id ?? null;
      state.currentFloor = action.payload; 
      if (newId !== oldId) {
        state.floorLoading = true;
      }
    },
    setFloorLoading(state, action) {
      state.floorLoading = action.payload;
    },
    setSelectedPin(state, action) {
      // state.selectedPin = action.payload;
      state.selectedPin = {
        ...state.selectedPin,
        ...action.payload
      };
    },
    setShowLocationPicker(state, action) {
      state.showLocationPicker = action.payload;
    },
    setEditingBoundary(state, action) {
      state.editingBoundary = action.payload;
    },

    resetProjectState() {
      return initialState;
    },
  },
});

export const {
  setActiveTab,
  setEditingPinId,
  setProjectData,
  setAllPins,
  setFloorList,
  setPinCount,
  setCurrentFloor,
  setFloorLoading,
  setPinsByCategory,
  setSelectedPin,
  setShowLocationPicker,
  setEditingBoundary,
  resetProjectState,
} = projectItemSlice.actions;

export default projectItemSlice.reducer;
